import React 					from "react"
import {TextField, Checkbox, PasswordField, Select, PrimaryButton, SecondaryButton} 	from "../Ui"
import LinkUrl 					from "../common/components/Link";
import { Link } 				from "react-router";
import styled				from 'styled-components';
import Banner					from "../common/components/layouts/Banner";



const SubscribeFormUser = ({
	fields,
	onTextFieldChange,
	onSubmit,
}) =>{

	const optionsCivility = [
		{text: "Mme", 	value: 1},
		{text: "Mlle", 	value: 2},
		{text: "M", 	value: 3},
	];

	const optionsFunction = [
		{text: "Acheteur", 				value: 1},
		{text: "Adjoint", 				value: 2},
		{text: "Bur. étude & méthode", 	value: 3},
		{text: "Chargé d'affaires", 	value: 4},
		{text: "Chef d'atelier", 		value: 5},
		{text: "Chef de travaux", 		value: 6},
		{text: "Comptable", 			value: 7},
		{text: "Conducteur de trav.", 	value: 8},
		{text: "Directeur Commercial", 	value: 9},
		{text: "Directeur Général", 	value: 10},
		{text: "Directeur technique", 	value: 11},
		{text: "Econome - Gestionn.", 	value: 12},
		{text: "Intendant", 			value: 13},
		{text: "Maire", 				value: 14},
		{text: "Métreur", 				value: 15},
		{text: "PDG -Gérant", 			value: 16},
		{text: "Resp. Commercial", 		value: 17},
		{text: "Resp. de magasin", 		value: 18},
		{text: "Resp. de production", 	value: 19},
		{text: "Resp. de service", 		value: 20},
		{text: "Resp. des achats", 		value: 21},
		{text: "Resp. serv.Entretien", 	value: 22},
		{text: "Resp Service Marchés", 	value: 23},
		{text: "Resp.Ser.Municipaux", 	value: 24},
		{text: "Secrétaire", 			value: 25},
		{text: "Technicien", 			value: 26},
	];

	const LOGO_LEGALLAIS_URL = require("../../assets/legallais.png")

	const Footer = styled.footer`
		margin-top: auto;
		padding: 10px;
		text-align: center;
		font-size: 14px;
		font-weight: 500;
	`

	return (

		<div>
			<Banner />
			<div className="subscribe-form__wrapper">
				<h1 className="subscribe-form__header">Identidiants internet</h1>
				<div className="subscribe-form__contain">
					<div className="subscribe-form__column">
						<h2>Information client</h2>

						<div className="subscribe-form__field">
							<TextField
								label="Code client"
								name="customerCode"
								value={fields.customerCode}
								onChange={onTextFieldChange} />
						</div>
						<div className="subscribe-form__field">
							<TextField
								label="Code postal société"
								name="postalCode"
								value={fields.postalCode}
								onChange={onTextFieldChange} />
						</div>
					</div>
					<div className="subscribe-form__column">
						<h2>Information utilisateur</h2>
						<Select
							label="Civility"
							placeholder="Choisissez votre civilité"
							name="civility"
							options={optionsCivility}
							value={fields.civility}
							onChange={onTextFieldChange} />
						<div className="subscribe-form__field">
							<TextField
								label="Nom"
								name="lastName"
								value={fields.lastName}
								onChange={onTextFieldChange} />
						</div>
						<div className="subscribe-form__field">
							<TextField
								label="Prénom"
								name="firstName"
								value={fields.firstName}
								onChange={onTextFieldChange} />
						</div>
						<div className="subscribe-form__field">
							<TextField
								label="Email"
								name="email"
								value={fields.email}
								onChange={onTextFieldChange} />
						</div>
						<Select
							label="Fonction"
							placeholder="Choisissez votre fonction"
							name="function"
							options={optionsFunction}
							value={fields.function}
							onChange={onTextFieldChange} />
						<div className="subscribe-form__field">
							<PasswordField
								label="Mot de passe"
								name="password"
								value={fields.password}
								onChange={onTextFieldChange} />
						</div>
					</div>
				</div>

				<div className="subscribe-form__validation">
					<div className="subscribe-form__conditions">
						<label className="auth__checkbox-label">
							<Checkbox
								name="termsOfSales"
								checked={fields.termsOfSales}
								onClick={onTextFieldChange}
							/>
						</label>
						<p>Je déclare avoir pris connaissance des <LinkUrl url="https://www.legallais.com/conditionsgenerales.html">conditions générales de vente</LinkUrl> et en accepte les termes en cochant cette case </p>
					</div>

					<div className="subscribe-form__actions">
						<Link to={"/"}>
							<div style={{marginRight: "20px"}}>
								<SecondaryButton>Annuler</SecondaryButton>
							</div>
						</Link>

						<PrimaryButton
							disabled = {!fields.termsOfSales}
							onClick={onSubmit}>Valider mon inscription</PrimaryButton>
					</div>
				</div>
			</div>
			<div className="susbcribe__button">
				<SecondaryButton className="subcribe__help-button" iconName="help">
					<span>Aide</span>
				</SecondaryButton>
			</div>
			<Footer className="subscribe-choice__footer">
				<span>Un outil pour créer vos organigrammes par <img src={LOGO_LEGALLAIS_URL} /></span>
			</Footer>
		</div>

		)
}

export default SubscribeFormUser



// WEBPACK FOOTER //
// ./src/js/subscribe/SubscribeFormUser.js